














import { Component, Prop, Vue, Inject } from 'vue-property-decorator';

import {
  type ISmi24BlockUseCase,
  SMI24_BLOCK_USE_CASE_KEY,
} from '@jtnews/shared/seedwork/frontend/application';
import { NoSSR, UiObserveVisibility } from '@jtnews/shared/ui';

@Component({
  name: 'Smi24Block',
  components: { UiObserveVisibility, NoSSR },
})
export default class Smi24Block extends Vue {
  @Prop({
    type: Number,
    default: 0,
  })
  partnerId: number;

  @Inject(SMI24_BLOCK_USE_CASE_KEY)
  private readonly _useCase!: ISmi24BlockUseCase;

  get script() {
    return this._useCase.getWidgetScript(this.partnerId);
  }

  mounted() {
    this._useCase.inject();
  }

  processViewAdd() {
    this._useCase.processViewAdd();
  }

  processClickAdd() {
    this._useCase.processClickAdd();
  }
}
